import React from "react";
import useAuth from "../providers/authProvider";


export const PrivateRoute = ({ component: Component, ...rest }: any) => {
    const { isAuthenticated, signinRedirect, role } = useAuth();

    if (isAuthenticated()) {
        if ( rest.rules.indexOf(role) !== -1) {
            return <Component {...rest} />;
        }
        return <p> No Access...</p>
    } else {
        signinRedirect();
        return <p> Loading...</p>
    }
};
